import React, { useEffect, useState } from "react";
import "./VerificationFinalpage.scss";
import { signOut } from "firebase/auth";
import { useCookies } from "react-cookie";
import { auth } from "../../../features/firebase";
import useAuthStore from "../../../features/store";
import Loading from "../../components/Loading/Loading";
import { useNavigate } from "react-router-dom";

const VerificationFinalpage = ({ user }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  // eslint-disable-next-line
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const { clearUserDB } = useAuthStore();

  useEffect(() => {
    if (user && user.emailVerified) {
      navigate("/");
    } else if (!user) {
      navigate("/login");
    }
  }, [user, navigate]);

  const handleLogoutAndRedirect = async () => {
    try {
      setLoading(true);
      await signOut(auth);
      removeCookie("user");
      localStorage.removeItem("emailSent");
      clearUserDB();
      window.location.href = "http://localhost:3000/login";
    } catch (error) {
      console.error("Error saat logout:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleResendCode = () => {
    localStorage.removeItem("emailSent");
    navigate("/verifikasi");
  };

  return (
    <main className="verification-final-page">
      {loading && <Loading />}
      <div className="verification-final-box">
        <h1>Perhatian</h1>
        <div>
          <p style={{ color: "yellow" }}>
            kita sudah mengirim verifikasi ke gmail kamu
          </p>
          <p>
            Setelah melakukan verifikasi di gmail, kamu harus login ulang dengan
            menekan tombol dibawah
          </p>
        </div>

        <div className="verification-final-button">
          <button onClick={handleLogoutAndRedirect}>
            Login Ulang <i class="fa-solid fa-right-to-bracket"></i>
          </button>
          <button onClick={handleResendCode}>
            Regenerate <i class="fa-solid fa-repeat"></i>
          </button>
        </div>
      </div>
    </main>
  );
};

export default VerificationFinalpage;
